module.exports = __webpack_public_path__ + "static/media/Chris_F.e750f87f.jpg";